import { cn } from '../../lib/cn';
import type { SecurityExperienceRow } from '../../masterplatform/framework';

type Props = { items?: SecurityExperienceRow[] };

export function SecurityExperiencePanel({ items = [] }: Props) {
  return (
    <div className="grid gap-2 sm:grid-cols-2">
      {items.map((item) => (
        <div key={`${item.domain}-${item.standard}`} className="rounded-lg border border-slate-200 p-3 dark:border-slate-700">
          <p className="text-xs text-slate-500">{item.domain}</p>
          <p className="text-sm font-medium">{item.standard}</p>
          <span className={cn(
            'mt-1 inline-block rounded-full px-2 py-0.5 text-xs font-medium',
            item.status === 'enforced' || item.status === 'compliant' || item.status === 'validated'
              ? 'bg-success-50 text-success-700 dark:bg-success-950 dark:text-success-300'
              : 'bg-brand-50 text-brand-700 dark:bg-brand-950 dark:text-brand-300',
          )}>
            {item.status}
          </span>
        </div>
      ))}
    </div>
  );
}
